import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { ActivityResponseDto, CreateActivityDto } from '@/shared/types/activite'

export const activitesApi = {
  getByEtudiantId: (etudiantId: number) =>
    api
      .get<ApiResponse<ActivityResponseDto[]>>(`/api/activities/etudiant/${etudiantId}`)
      .then((r) => r.data.data),

  create: (etudiantId: number, data: CreateActivityDto) =>
    api
      .post<ApiResponse<ActivityResponseDto>>(`/api/activities/etudiant/${etudiantId}`, data)
      .then((r) => r.data.data),

  delete: (activityId: number, etudiantId: number) =>
    api
      .delete<ApiResponse<void>>(`/api/activities/${activityId}?etudiantId=${etudiantId}`)
      .then((r) => r.data),
}
